module.exports = __webpack_public_path__ + "static/media/poorwill11.5b82dd48.JPG";